module.exports = __webpack_public_path__ + "913d028f82a76afecb71dcc6c2c5e47f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NZ.svg
// module id = ymp2
// module chunks = 0